import { FunctionComponent, useCallback, useEffect } from 'react';
import 'react-day-picker/lib/style.css';
import { format, isValid, parseISO } from 'date-fns';

import ReactDatePicker from 'react-date-picker';

import { Label } from '../Label';

import classes from '../text-input.module.scss';
import classNames from 'classnames';

export type DatePickerProps = {
  label?: string;
  onChange: (date: string) => any;
  required?: boolean;
  value: string;
};

export const DatePicker: FunctionComponent<DatePickerProps> = ({
  label,
  onChange,
  required = false,
  value,
}) => {
  const onChangeHandler = useCallback(
    (date: Date | Date[]) => {
      if (!Array.isArray(date)) {
        onChange(format(date, 'yyyy-MM-dd'));
      }
    },
    [onChange]
  );

  const valueAdapter = useCallback(() => {
    if (!isValid(parseISO(value))) {
      return new Date();
    }

    return parseISO(value);
  }, [value]);

  useEffect(() => {
    const date = parseISO(value);

    if (!isValid(date)) {
      onChangeHandler(new Date());
    }
  }, [onChangeHandler, value]);

  return (
    <div>
      {label && <Label>{label}</Label>}
      <div>
        <ReactDatePicker
          className={classNames(classes.input, classes.datePicker)}
          onChange={onChangeHandler}
          value={valueAdapter()}
          required={required}
          maxDate={new Date()}
        />
      </div>
    </div>
  );
};
